<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="listQuery.bill_number" placeholder="请输入提单号" style="width: 200px;" clearable @clear="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="listQuery.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @clear="SearchData"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <!-- 弹窗层编辑 -->
      <el-button class="action-item" type="primary" icon="el-icon-plus" @click="HandleCreate">单条记录</el-button>
      <el-button class="action-item" type="success" icon="el-icon-upload" @click="BatchCheck">核验</el-button>
      <!-- <el-button class="action-item" type="danger" icon="el-icon-delete" @click="BatchDelete">删除</el-button> -->
      <el-button class="action-item" type="warning" icon="el-icon-upload2" @click="dialogImportVisible = true">批量导入</el-button>
      <el-button class="action-item" type="info" icon="el-icon-download" @click="Handledownload">下载模版</el-button>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange" @selection-change="handleSelectionChange">
      <!--列开始-->
      <el-table-column align="center" type="selection"></el-table-column>
      <el-table-column align="center" type="index" width="50" label="序号 "></el-table-column>
      <el-table-column align="center" prop="bill_number" label="提单号 " show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="create_time" label="导入时间 "> </el-table-column>
      <el-table-column align="center" prop="user_num" label="用户数量 "> </el-table-column>
      <el-table-column align="center" prop="check_num" label="已核验 "> </el-table-column>
      <el-table-column align="center" prop="no_check_num" label="未核验 "> </el-table-column>
      <el-table-column align="center" prop="consistent_num" label="一致数 "> </el-table-column>
      <el-table-column align="center" prop="no_consistent_num" label="不一致数 "> </el-table-column>
      <el-table-column align="center" prop="cost_num" label="计费次数 "> </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="300" class-name="action">
        <template slot-scope="scopes">
          <el-button v-if="scopes.row.status === 1" size="mini" disabled type="success" plain icon="el-icon-upload">核验{{ scopes.row.bl }}%</el-button>
          <el-button v-else size="mini" type="success" plain icon="el-icon-upload" @click="HandleCheck(scopes.row,1)">核验</el-button>
          <!-- <el-button size="mini" type="success" plain icon="el-icon-upload" @click="HandleCheck(scopes.row,1)">核验</el-button> -->
          <el-button v-if="scopes.row.is_jx === 1" v-auth="'Check.continue'" size="mini" type="success" plain icon="el-icon-upload" @click="HandleCheck(scopes.row,2)">继续核验</el-button>
          <el-button size="mini" type="primary" plain icon="el-icon-view" @click="HandleDetail(scopes.row)">查看</el-button>
          <el-button v-if="scopes.row.check_num === 0" size="mini" type="danger" plain icon="el-icon-delete" @click="RowDelete(scopes.row)">删除</el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible" width="600px">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="110px" style="width: 93%;">
        <el-form-item label="提单号 " prop="bill_number">
          <el-input v-model="temp.bill_number" placeholder="请输入提单号" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="运单号 " prop="waybill_number">
          <el-input v-model="temp.waybill_number" placeholder="请输入运单号" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="姓名 " prop="name">
          <el-input v-model="temp.name" placeholder="请输入姓名" maxlength="10" show-word-limit />
        </el-form-item>
        <el-form-item label="身份证号 " prop="idcard">
          <el-input v-model="temp.idcard" placeholder="请输入身份证号" />
        </el-form-item>
        <el-form-item label="状态 " prop="status">
          <el-radio-group v-model="temp.status">
            <el-radio :label="1">未核验</el-radio>
            <!-- <el-radio :label="2">已核验</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="录入时间 " prop="create_time">
          <el-date-picker
            v-model="temp.create_time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitData">保存</el-button>
      </div>
    </el-dialog>
    <!--导入-->
    <el-dialog title="导入文件" :visible.sync="dialogImportVisible" width="600px">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="选择文件">
          <el-upload
            class="upload-demo"
            :action="upload_url"
            :headers="requestHeaders"
            :limit="1"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-remove="handleRemove"
            accept=".xlsx"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogImportVisible = false">取消</el-button>
        <el-button type="primary" :disabled="!import_file.name" @click="BatchImport">导入</el-button>
      </div>
    </el-dialog>
    <!-- 导入错误信息 -->
    <el-dialog
      title="导入完成"
      :visible.sync="dialogImportErrorVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <div style="margin-bottom:20px;">{{ import_error.success || 0 }}条数据导入成功，{{ import_error.error.length || 0 }}条数据导入失败：</div>
      <div v-if="import_error.error" style="height:240px;overflow-y: scroll;">
        <div v-for="(txt,index) in import_error.error" :key="index" style="margin:3px 0;">{{ txt }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogImportErrorVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 核验错误信息 -->
    <el-dialog
      title="核验完成"
      :visible.sync="dialogCheckErrorVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <div style="margin-bottom:20px;">{{ check_error.success || 0 }}条数据核验成功，{{ check_error.error.length || 0 }}条数据核验失败：</div>
      <div v-if="check_error.error" style="height:240px;overflow-y: scroll;">
        <div v-for="(txt,index) in check_error.error" :key="index" style="margin:3px 0;">{{ txt }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCheckErrorVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/user_group' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import dict_data from '@/api/system/dict_data'
import { getToken } from '@/utils/auth'
import { Loading } from 'element-ui'
export default {
  name: 'Lists',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      upload_url: process.env.VUE_APP_BASE_API + 'admin/Resources/Upload',
      requestHeaders: {
        'Authorization': 'Bearer ' + getToken()
      },
      // api接口方法
      api,
      // 校验
      rules: {
        bill_number: [{ required: true, message: '请输入提单号', trigger: ['blur', 'change'] }],
        waybill_number: [{ required: true, message: '请输入运单号', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }],
        idcard: [{ required: true, validator: (rule, value, callback) => {
          const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
          if (!value) {
            callback(new Error('请输入身份证号'))
          } else if (!reg.test(value)) {
            callback(new Error('请输入正确的身份证号'))
          } else {
            callback()
          }
        }, trigger: ['blur', 'change'] }],
        create_time: [{ required: true, message: '请选择录入时间', trigger: ['blur', 'change'] }]
      },
      temp: {
        id: undefined,
        bill_number: '',
        waybill_number: '',
        name: '',
        idcard: '',
        status: 1,
        create_time: ''
      },
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'asc', // 默认排序方式,
        sort: 'order_no'
      },
      dialogImportVisible: false,
      import_file: {
        file: '',
        name: ''
      },
      import_error: {
        success: 0,
        error: [],
        num: 2,
        bl: 0
      },
      lock: false,
      dialogImportErrorVisible: false,

      dialogCheckErrorVisible: false,
      check_error: {
        // success: 0,
        // error: [],
        totalNum: 0, // 总条数
        checkNum: 0, // 核验条数
        yes: 0, // 一致数
        no: 0, // 不一致数
        null: 0, // 无记录(预留)数
        error: 0, // 信息错误数
        end_id: 0,
        bl: 0
      },
      mloading: null,
      checktype: 0

    }
  },
  created() {
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: '' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    BatchCheck() {
      this.checktype = 1
      if (!this.selectIds || this.selectIds.length === 0) {
        this.$notify({ message: '请先选择批次数据', type: 'warning', duration: 2000 })
      } else {
        this.$confirm('确定要核验吗?', '提示', {
          confirmButtonText: '确定核验',
          cancelButtonText: '取消'
        }).then(() => {
          this.ConfimCheck(this.selectIds)
        })
      }
    },
    HandleCheck(row, type) {
      this.checktype = type
      let msg = '确定要核验吗?'
      if (type === 2) {
        msg = '确定要继续核验吗?'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定核验',
        cancelButtonText: '取消'
      }).then(() => {
        if (type === 1) {
          this.ConfimCheck([row.id])
        } else {
          this.submitCheck([row.id])
        }
      })
    },
    ConfimCheck(ids) {
      if (!ids || ids.length === 0) {
        return
      }
      if (this.lock === true) return
      this.lock = true
      api.IsChecked({ ids: ids }).then(res => {
        if (res.data) {
          this.$confirm(res.data, '提示', {
            confirmButtonText: '确定核验',
            cancelButtonText: '取消'
          }).then(() => {
            this.submitCheck(ids)
          }).catch(() => {
            this.lock = false
          })
        } else {
          this.submitCheck(ids)
        }
      }).catch(() => {
        this.lock = false
      })
    },
    submitCheckOld(ids) {
      api.Check({
        ids: ids
      }).then(() => {
        this.loadData()
        this.lock = false
      }).catch(() => {
        this.lock = false
      })
    },
    submitCheck(ids) {
      if (this.mloading) {
        this.mloading.setText('正在核验，请勿刷新页面，请勿关闭页面  (' + this.check_error.bl + '%)')
      } else {
        this.mloading = Loading.service({
          lock: true,
          text: '正在核验，请勿刷新页面，请勿关闭页面  (' + this.check_error.bl + '%)',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      api.Check({
        ids: ids,
        type: this.checktype,
        end_id: this.check_error.end_id
      }).then(response => {
        this.check_error.totalNum += response.data.totalNum
        this.check_error.checkNum += response.data.checkNum
        this.check_error.yes += response.data.yes
        this.check_error.no += response.data.no
        this.check_error.null += response.data.null
        this.check_error.error += response.data.error
        this.check_error.bl = Math.round(response.data.bl)
        this.check_error.end_id = response.data.end_id
        if (response.data.bl !== 100) {
          this.submitCheck(ids)
        } else {
          this.$store.dispatch('user/getInfo')
          this.$nextTick(() => {
            this.mloading.close()
            this.mloading = null
          })
          this.loadData()
          const h = this.$createElement
          this.$msgbox({
            title: '核验完成',
            message: h('p', null, [
              h('span', null, '总数： ' + this.check_error.totalNum + '，'),
              h('span', { style: 'color: #409EFF' }, '已核验数： ' + this.check_error.checkNum + '，'),
              h('span', { style: 'color: #67C23A' }, '一致数： ' + this.check_error.yes + '，'),
              h('span', { style: 'color: #E6A23C' }, '不一致数： ' + this.check_error.no + '，'),
              // h('span', { style: 'color: #000000' }, '无记录数： ' + this.check_error.null + '，')
              h('span', { style: 'color: #F56C6C' }, '数据不规范： ' + this.check_error.error)
            ]),
            confirmButtonText: '关闭'
          })
          this.resetCheckError()
          setTimeout(() => {
            this.lock = false
          }, 2000)
        }
      }).catch(() => {
        this.lock = false
        this.$nextTick(() => {
          this.mloading.close()
          this.mloading = null
          this.resetCheckError()
          this.loadData()
        })
      })
    },
    resetCheckError() {
      this.check_error = {
        // success: 0,
        // error: [],
        totalNum: 0, // 总条数
        checkNum: 0, // 核验条数
        yes: 0, // 一致数
        no: 0, // 不一致数
        null: 0, // 无记录(预留)数
        error: 0, // 信息错误数
        end_id: 0,
        bl: 0
      }
    },
    HandleDetail(row) {
      this.$router.push(`/detail?group_id=${row.id}`)
    },
    Handledownload() {
      window.open(process.env.VUE_APP_BASE_API + '/static/document/bill of lading.xlsx')
    },
    handleSelectionChange(val) {
      this.selectIds = val.map(i => i.id)
    },
    BatchImport() {
      if (this.lock === true) return
      this.lock = true
      this.import_error = {
        success: 0,
        error: [],
        num: 2,
        bl: 0
      }
      this.submitImport()
    },
    submitImport() {
      if (this.mloading) {
        this.mloading.setText('正在导入，请等待  (' + this.import_error.bl + '%)')
      } else {
        this.mloading = Loading.service({
          lock: true,
          text: '正在导入，请等待  (' + this.import_error.bl + '%)',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      api.Import(this.import_file).then(response => {
        this.import_error.success += response.data.success
        if (response.data.error.length > 0) {
          response.data.error.map(i => {
            this.import_error.error.push(i)
          })
        }
        this.import_error.bl = Math.round(response.data.bl)
        console.log('Updated import_error.bl:', this.import_error.bl) // 添加调试信息
        if (response.data.bl !== 100) {
          this.import_file.num = response.data.num
          this.submitImport()
        } else {
          this.dialogImportVisible = false
          this.$nextTick(() => {
            this.mloading.close()
            this.mloading = null
          })
          this.loadData()
          this.dialogImportErrorVisible = true
          setTimeout(() => {
            this.lock = false
          }, 2000)
        }
      }).catch(() => {
        this.lock = false
        this.$nextTick(() => {
          this.mloading.close()
          this.mloading = null
        })
      })
    },
    handleRemove(file, fileList) {
      this.import_file = {
        file: '',
        name: ''
      }
    },
    uploadSuccess(response, file, fileList) { // 新文件上传成功后重新加载列表
      console.log(response, file, fileList)
      if (response.code !== 20000) {
        this.$message.error(response.msg)
      } else {
        this.import_file = {
          file: response.message,
          name: file.name.substring(0, file.name.lastIndexOf('.'))
        }
      }
    },
    uploadError() {
      this.$message.error('上传错误')
    },
    submitData() {
      api.IsExist(this.temp).then(res => {
        if (res.data === 1) {
          this.$confirm('人员已存在，确定要覆盖吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.ConfirmData()
          })
        } else {
          this.ConfirmData()
        }
      })
    },
    resetTemp() {
      const date = new Date()
      date.valueFormat = 'yyyy-MM-dd HH:mm:ss'
      this.temp = {
        id: undefined,
        bill_number: '',
        waybill_number: '',
        name: '',
        idcard: '',
        status: 1,
        create_time: date
      }
    }

  }
}
</script>
<style>
.el-form-item__label{
  padding:0 20px 0 0
}
</style>
